module.exports = __webpack_public_path__ + "static/media/services-stripes-gray.ab6a1bf2.svg";